import React, { Component } from 'react';
import withHooks from '../../core/withHooks';
import { Layout } from '../common';
import { DashboardTabs } from './elements';
import DashboardController from './dashboard.controller';
import Inherit from '../../core/inherit';
import styles from './styles/dashboard.module.scss';
import { Button } from 'antd';

class Dashboard extends Inherit(DashboardController, Component) {
    state = {
        user: {},
        report: {},
        loading: true,
        dateRange: null,
        timeFrame: '30d',
        ytdReport: {},
        availableGroupings: ['weekly', 'daily'], // Default groupings for last month
        selectedGrouping: 'weekly', // Default selection
        showConfigurationReminder: false
    };

    componentDidUpdate(prevProps, prevState) {
        const { showConfigurationReminder } = this.state;
        const { notificationApi } = this.props;
        const notificationKey = 'configuration-reminder';

        if (showConfigurationReminder && !prevState.showConfigurationReminder) {
            notificationApi.info({
                key: notificationKey,
                message: 'Complete your configuration',
                description: 'Finish setting up your Clockout configuration so your users can access the experience.',
                placement: 'topRight',
                duration: 0,
                btn: (
                    <Button type="primary" size="small" onClick={() => this.handleConfigurationReminderAction(notificationKey)}>
                        Go to configurations
                    </Button>
                ),
                onClose: () => this.handleConfigurationReminderDismiss(),
                closeIcon: null
            });
        } else if (!showConfigurationReminder && prevState.showConfigurationReminder) {
            notificationApi.destroy(notificationKey);
        }
    }

    handleConfigurationReminderAction(notificationKey) {
        const { notificationApi } = this.props;
        notificationApi.destroy(notificationKey);
        this.handleConfigurationReminderDismiss();
        this.navigateConfigurations();
    }

    render() {
        const { user, report, loading } = this.state;
        const { notificationContextHolder } = this.props;
        return (
            <Layout user={user} fi={user?.fi?.name}>
                {notificationContextHolder}
                <div className={styles.dashboardContainer}>
                    <p className={styles.welcomeMessage}>Welcome, {user?.name} </p>
                    <DashboardTabs report={report} loading={loading} data={this.data} />
                </div>
            </Layout>
        );
    }
}

export default withHooks(Dashboard);
